import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent {
  @Input() searchBarClass: string | undefined;
  @Input() inputValue: string | undefined;
  @Input() placeholder: string = "...";
  @Input() isFullScreen: boolean = false;
  @Output() searchQuery: EventEmitter<string> = new EventEmitter();
  @Input() id: string = "searchQuery";
  @Input() minWidth: string | undefined;

  constructor(public translocoService: TranslocoService) {
  }

}
